import { render, staticRenderFns } from "./trawl-main-menu-detail.vue?vue&type=template&id=56540b1c"
import script from "./trawl-main-menu-detail.vue?vue&type=script&lang=js"
export * from "./trawl-main-menu-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports